<template>
<!-- 编辑器弹窗：插入公式 -->
    <el-dialog class="pai" title="插入公式" :visible.sync="dialogVisible" width="578px" @close="close" :close-on-click-modal="false" :close-on-press-escape="false">
        <iframe src="static/kityformula/kityformula.html" width="100%" height="420px"></iframe>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="submitForm('form')">确定</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    props: ['show'],
    data() {
        return {
            dialogVisible: false,
            form: {
                value: ['']
            },
            submit: false
        };
    },
    watch: {
        show() {
            this.submit = false
            this.dialogVisible = this.show;
        }
    },
    methods: {      
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
            if (valid) {
                this.dialogVisible = false
                this.submit = true
            } else {
                console.log('error submit!!');
                return false;
            }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        remove(i) {
            // var index = this.form.value.indexOf(item)
            // if (index !== -1) {
            this.form.value.splice(i, 1)
            // }
        },
        add() {
            this.form.value.push('');
        },
        close() {
            var data = this.form.value.join("|")
            this.form.value = ['']
            if (this.submit) {
                this.$emit('close', '[['+data+']]')
            }else {
                this.$emit('close', false)
            }
        },
    }
};
</script>

<style>
    .el-upload, .el-upload-dragger {
        width: 100%;
    }
    .pai .el-dialog .el-dialog__body{
        padding: 0;
        height: 420px;
        overflow: auto;
    }
</style>